(function () {
  window.__alaricAddonsLoaded = true;

  function getCheckedAddonVariantIds() {
    return Array.from(document.querySelectorAll(".addon-checkbox:checked"))
      .map(function (cb) {
        return cb.getAttribute("data-variant-id");
      })
      .filter(Boolean);
  }

  function findProductForm(el) {
    if (!el) return null;

    var form = el.closest("form");
    if (form && form.querySelector('input[name="id"]')) return form;

    var forms = Array.from(document.querySelectorAll("form")).filter(function (f) {
      return f.querySelector('input[name="id"]');
    });

    return forms.length ? forms[0] : null;
  }

  function getMainVariantId(form) {
    var input = form ? form.querySelector('input[name="id"]') : null;
    return input && input.value ? input.value : null;
  }

  function getQuantity(form) {
    if (!form) return 1;

    var qtyInput =
      form.querySelector('input[name="quantity"]') ||
      form.querySelector('input[type="number"]');

    var qty = parseInt(qtyInput && qtyInput.value, 10);
    return !isNaN(qty) && qty > 0 ? qty : 1;
  }

  function addItems(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error("Add to cart failed");
      return res.json();
    });
  }

  function clearAddonCheckboxes() {
    document.querySelectorAll(".addon-checkbox:checked").forEach(function (cb) {
      cb.checked = false;
    });
  }

  function handleAddToCart(el, evt) {
    var addonIds = getCheckedAddonVariantIds();
    if (!addonIds.length) return;

    var form = findProductForm(el);
    if (!form) return;

    var mainVariantId = getMainVariantId(form);
    if (!mainVariantId) return;

    evt.preventDefault();
    evt.stopPropagation();
    if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();

    var mainQty = getQuantity(form);

    // Build add-on items (qty 1 each)
    var addonItems = addonIds.map(function (id) {
      return { id: id, quantity: 1 };
    });

    // Important for your cart page: Shopify is showing newest-first.
    // So we add add-ons FIRST, then hero LAST so hero appears at the top.
    addItems(addonItems)
      .then(function () {
        return addItems([{ id: mainVariantId, quantity: mainQty }]);
      })
      .then(function () {
        clearAddonCheckboxes();
        window.location.href = "/cart";
      })
      .catch(function () {
        // Fallback to normal form submit
        try {
          form.submit();
        } catch (e) {}
      });
  }

  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || !form.querySelector('input[name="id"]')) return;
      handleAddToCart(form, e);
    },
    true
  );

  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest('button[type="submit"], button[name="add"]');
      if (!btn) return;
      handleAddToCart(btn, e);
    },
    true
  );
})();